/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Custom-event admin pages and their type/example labels.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CustomEventConversionTypeLabelComponent} from './custom-event-conversion-type-label-component';
import {CustomEventTypeLabelComponent} from './custom-event-type-label-component';
import {CustomEventConversionTypeDescriptionComponent} from './custom-event-conversion-type-description-component';
import {CustomEventExampleCodeComponent} from './custom-event-example-code-component';
import {CustomEventEditPageComponent} from './custom-event-edit-page.component';
import {CustomEventListPageComponent} from './custom-event-list-page.component';
import {CustomEventRoutePageComponent} from './custom-event-route-page.component';

const CUSTOM_EVENT = [
  CustomEventConversionTypeLabelComponent,
  CustomEventTypeLabelComponent,
  CustomEventConversionTypeDescriptionComponent,
  CustomEventExampleCodeComponent,
  CustomEventEditPageComponent,
  CustomEventListPageComponent,
  CustomEventRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule
  ],
  declarations: CUSTOM_EVENT,
  exports: CUSTOM_EVENT
})
export class CustomEventModule {
}
